import gsap from "gsap";
import { ScrollTrigger, SplitText } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class ScrollObserver extends DefaultBlock {
	// Define initial variables and call the createTimeline
	init() {
		this.selectors = {
			block: gsap.utils.selector(this.block),
			heading: gsap.utils.selector(".scroll-observer__heading"),
		};

		this.DOM = {
			heading: this.selectors.block(".scroll-observer__heading")[0],
			headingText: this.selectors.heading(".heading-l"),
			circle: this.selectors.block(".scroll-observer__heading-svg"),
		};

		this.createTimeline();
	}

	// Split the heading text into words and character divs
	// using the wordsClass property to make selecting the letters easier
	splitText() {
		new SplitText(this.DOM.heading, {
			type: "words, chars",
			wordsClass: "scroll-observer__heading-word--++",
		});
	}

	observerAnimation() {
		// splitText letter variables
		const letterB = this.selectors.heading(
			".scroll-observer__heading-word--1 div:nth-of-type(1)"
		);
		const letterE = this.selectors.heading(
			".scroll-observer__heading-word--5 div:nth-of-type(4)"
		);
		const letterC = this.selectors.heading(
			".scroll-observer__heading-word--3 div:nth-of-type(5)"
		);
		const letterO = this.selectors.heading(
			".scroll-observer__heading-word--2 div:nth-of-type(2)"
		);
		const letterW = this.selectors.heading(
			".scroll-observer__heading-word--4 div:nth-of-type(1)"
		);

		// Create a repeating animation for the circle to
		// grow and shrink at 3 second intervals
		gsap.to(this.DOM.circle, {
			keyframes: [{ scale: 1.1 }, { scale: 1 }],
			duration: 1,
			repeat: -1,
			repeatDelay: 2,
		});

		// Create the observer timeline
		const observerTl = gsap.timeline({
			id: "scroll-observer",
			repeat: -1,
			repeatDelay: 1.7,
		});

		observerTl.to(this.DOM.circle, {
			top: "80%",
			left: "66%",
			duration: 1,
			ease: "expo.out",
		});

		observerTl.to(
			letterB,
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1,
				ease: "back.out",
			},
			"<"
		);

		observerTl.to(
			letterE,
			{ autoAlpha: 0, scale: 0, duration: 1, ease: "back.out" },
			"<=0.3"
		);

		observerTl.to(
			letterE,
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1,
				ease: "back.out",
			},
			"<=1.7"
		);

		observerTl.to(
			this.DOM.circle,
			{
				top: "30%",
				left: "88.5%",
				duration: 1,
				ease: "expo.out",
			},
			"<"
		);

		observerTl.to(
			letterC,
			{
				autoAlpha: 0,
				scale: 0,
				duration: 1,
				ease: "back.out",
			},
			"<=0.3"
		);

		observerTl.to(
			letterC,
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1,
				ease: "back.out",
			},
			"<=1.7"
		);

		observerTl.to(
			this.DOM.circle,
			{
				top: "30%",
				left: "48.2%",
				duration: 1,
				ease: "expo.out",
			},
			"<"
		);

		observerTl.to(
			letterO,
			{
				autoAlpha: 0,
				scale: 0,
				duration: 1,
				ease: "back.out",
			},
			"<=0.3"
		);

		observerTl.to(
			letterO,
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1,
				ease: "back.out",
			},
			"<=1.7"
		);

		observerTl.to(
			this.DOM.circle,
			{
				top: "80%",
				left: "9%",
				duration: 1,
				ease: "expo.out",
			},
			"<"
		);

		observerTl.to(
			letterW,
			{
				autoAlpha: 0,
				scale: 0,
				duration: 1,
				ease: "back.out",
			},
			"<=0.3"
		);

		observerTl.to(
			letterW,
			{
				scale: 1,
				autoAlpha: 1,
				duration: 1,
				ease: "back.out",
			},
			"<=1.7"
		);

		observerTl.to(
			this.DOM.circle,
			{
				top: "30%",
				left: "5.5%",
				duration: 1,
				ease: "expo.out",
			},
			"<"
		);

		observerTl.to(
			letterB,
			{
				autoAlpha: 0,
				scale: 0,
				duration: 1,
				ease: "back.out",
			},
			"<=0.3"
		);
	}

	createTimeline() {
		watchPreferredMotion(() => {
			this.splitText();
			this.observerAnimation();
		});
	}
}
